// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__WMJ7v {
  height: 100%;
  transition: all 0.5s ease-in-out;
  overflow-x: hidden; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/SplitScreen/TitleSection/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB,EAAA","sourcesContent":[".container {\n  height: 100%;\n  transition: all 0.5s ease-in-out;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__WMJ7v`
};
export default ___CSS_LOADER_EXPORT___;
